export default __webpack_public_path__ + "static/benefitSectionBg-cb8b2fc99b0978403f36e04a605ec7e5.png";